/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_D4dInputs */

const en_mk_sol_ukm_d4d = /** @type {(inputs: Mk_Sol_Ukm_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A broadcast to past customers waits for one tap from the owner before it really goes out.`)
};

const id_mk_sol_ukm_d4d = /** @type {(inputs: Mk_Sol_Ukm_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast ke pelanggan lama menunggu satu ketukan dari pemilik sebelum benar-benar terkirim.`)
};

/**
* | output |
* | --- |
* | "A broadcast to past customers waits for one tap from the owner before it really goes out." |
*
* @param {Mk_Sol_Ukm_D4dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_d4d = /** @type {((inputs?: Mk_Sol_Ukm_D4dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_D4dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_d4d(inputs)
	return en_mk_sol_ukm_d4d(inputs)
});